import { useRouter } from 'next/router';
import { useQuery } from '@apollo/client';
import {
  CATEGORY_SLUG_INDEX,
  SUBCATEGORY_SLUG_INDEX,
} from './useCurrentCategory/useCurrentCategory.constants';
import {
  CategoryBaseInfo,
  GetCategoryAdsCountResponse,
} from '@/api/types/categories.types';
import { GET_CATEGORY_ADS_COUNT } from '@/api/queries/categories.queries';
import { useParseQuery } from '@/hooks/useParseQuery/useParseQuery';
import { ROOT_CATEGORY_SLUG } from '@/constants/common';

export function useAdsCount(currentCategory?: CategoryBaseInfo | null): {
  adsCount: number | undefined;
  loading?: boolean;
} {
  const router = useRouter();
  const { keywords, price, regionId, propertyOptions, userLegacyId } =
    useParseQuery();

  const categorySlug = router.query.slug?.[CATEGORY_SLUG_INDEX];
  const subcategorySlug = router.query.slug?.[SUBCATEGORY_SLUG_INDEX];

  const path = [categorySlug, subcategorySlug].reduce(
    (acc, slug) => (slug ? `${acc}/${slug}` : acc),
    ROOT_CATEGORY_SLUG
  );

  const filters = {
    price,
    regionId,
    propertyOptions,
    userLegacyId,
  };

  const currentCategoryId = currentCategory?.path.includes('/')
    ? currentCategory?.id
    : '';

  const { data: adsCountData, loading } = useQuery<GetCategoryAdsCountResponse>(
    GET_CATEGORY_ADS_COUNT,
    {
      variables: {
        path,
        keywords,
        filters: { ...filters, categoryId: currentCategoryId },
      },
      skip: !currentCategory,
      notifyOnNetworkStatusChange: true,
    }
  );

  const adsCount = adsCountData?.category?.count;

  return {
    adsCount,
    loading,
  };
}
